import * as Sentry from '@sentry/react';
import { isSentryEnabled } from 'utils/environment/environment';

const errorNotifier = {
  notify: async (err: unknown, context = {}) => {
    if (isSentryEnabled()) {
      Sentry.captureException(err, { extra: context });
    } else {
      console.error(err);
    }
  },
  notifyWithFingerprint: async (
    err: Error,
    fingerprint: string[],
    context = {},
  ) => {
    if (isSentryEnabled()) {
      Sentry.captureException(err, { fingerprint, extra: context });
    } else {
      console.error(err);
    }
  },
};

export { errorNotifier };
